import { ANALYTICS_EVENT_OBJECT } from '@/constants/analytics';
import { ReactNode } from 'react';

export interface ExploreLayoutTab {
  id: string;
  title: string;
  iconClass: string;
  dataAnalyticsEventObject?: string;
  component?: ReactNode;
}

export const FILES_TAB: ExploreLayoutTab = {
  id: 'files',
  title: 'Files',
  iconClass: 'i-skand-files',
  dataAnalyticsEventObject: ANALYTICS_EVENT_OBJECT.FILE_TAB,
};

export const SCENE_TAB: ExploreLayoutTab = {
  id: 'scene',
  title: 'Layers',
  iconClass: 'i-skand-layers',
  dataAnalyticsEventObject: ANALYTICS_EVENT_OBJECT.LAYER_TAB,
};

export const VIEWER_TAB: ExploreLayoutTab = {
  id: 'viewer',
  title: 'Viewer',
  iconClass: 'i-skand-annotationgroup',
};

export const TEMPLATES_TAB: ExploreLayoutTab = {
  id: 'templates',
  title: 'Templates',
  iconClass: 'i-skand-templates',
  dataAnalyticsEventObject: ANALYTICS_EVENT_OBJECT.TEMPLATE_TAB,
};

export const SHARE_LINK_TAB = {
  id: 'sharelink',
  title: 'Share link',
  iconClass: 'i-skand-sharelink',
  dataAnalyticsEventObject: ANALYTICS_EVENT_OBJECT.SHARE_LINK_TAB,
};

export const PROCESS_TAB = {
  id: 'process',
  title: 'Process',
  iconClass: 'i-skand-gear',
  dataAnalyticsEventObject: ANALYTICS_EVENT_OBJECT.PROCESS_TAB,
};

export const DESKTOP_TABS = [FILES_TAB, SCENE_TAB, TEMPLATES_TAB, SHARE_LINK_TAB, PROCESS_TAB];
export const MOBILE_TABS = [SCENE_TAB, VIEWER_TAB];
export const SHARE_LINK_TABS = [FILES_TAB, SCENE_TAB];

// export const initialExploreLayoutTabs = getShareLinkToken() ? SHARE_LINK_TABS : DEFAULT_TABS;
export const initialExploreLayoutTabs = MOBILE_TABS;
